var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRomantic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.999875px",
    height: "8.53975px",
    viewBox: "0 0 9.999875 8.53975",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Large/Heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotelcard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ThemaBadge/Round/Romantic",
    transform: "translate(-11.000083, -11.896750)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Large/Heart",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.2678333,4.629 C11.2915,3.65266667 9.70866667,3.65266667 8.73233333,4.629 C8.244,5.11716667 8,5.757 8,6.39666667 C8,5.75683333 7.75583333,5.11716667 7.26783333,4.629 C6.2915,3.65266667 4.70866667,3.65266667 3.73233333,4.629 C2.756,5.60533333 2.756,7.18816667 3.73233333,8.1645 C3.73366667,8.16583333 3.73533333,8.16666667 3.73666667,8.168 L3.73416667,8.1705 L8,12.4365 L12.266,8.1705 L12.2635,8.168 C12.2648333,8.16666667 12.2665,8.16583333 12.2678333,8.1645 C13.244,7.18833333 13.244,5.60533333 12.2678333,4.629 Z",
    id: "Path",
    fill: "#2800A0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomantic);
export default __webpack_public_path__ + "static/media/Romantic.9b82678481b7933a5c674e30fb6466c8.svg";
export { ForwardRef as ReactComponent };